module.exports = __webpack_public_path__ + "static/media/b3.2491a2c.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lijunfeng/b3.mp3
// module id = Xybu
// module chunks = 0